import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Constants } from './constants';
import { ClientService } from './client.service';

@Injectable({
  providedIn: 'root'
})
export class WhatsappBotGuard implements CanActivate {
  private readonly allowedClientIds = Constants.WhatsAppBotIds;

  constructor(private router: Router, private clientService: ClientService) {}

  // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
  //   const clientId = Number(route.paramMap.get('clientId'));

  //   if (this.allowedClientIds.includes(clientId)) {
  //     return true;
  //   }

  //   this.router.navigate([`client/${clientId}/dashboard`]);

  //   return false;
  // }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const clientId = Number(route.paramMap.get('clientId'));

    // allowed by config
    if (this.allowedClientIds.includes(clientId)) {
      return true;
    }

    try {
      const res: any = await this.clientService.getPremiumBookings('whatsAppBot').toPromise();

      if (res && res.canAccess) {
        return true;
      }
    } catch (err) {
      console.log(err);
    }

    // not allowed → redirect
    this.router.navigate([`client/${clientId}/dashboard`]);
    return false;
  }
}
